// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"image_placeholder__8eJKX","feature":"image_feature__1bFUG","square":"image_square__3QIVx","poster":"image_poster__1rzmO","standard":"image_standard__1HSzI"};